document.addEventListener("DOMContentLoaded", function() {
    var colorButtons = document.querySelectorAll('.js-color-buttons');

    colorButtons.forEach(function(button) {
        var fieldset = button.closest('fieldset');
        var productId = fieldset.getAttribute('data-product-id');
        var size = fieldset.getAttribute('data-size');
        var colorValue = button.value;

        var product = all_variants.find(function(item) {
            return item.product_id === productId;
        });

        if (product) {
            var variant = product.variants.find(function(item) {
                return item.options[0] === size && item.options[1] === colorValue;
            });

            if (variant) {
                var inputId = button.id;

                var labels = fieldset.querySelectorAll('label');
                var label = Array.from(labels).find(function(label) {
                    return label.getAttribute('for') === inputId;
                });

                if (label) {
                    label.querySelector('img').src = variant.image;
                } else {
                    console.log('label not found for input with id:', inputId);
                }
            } else {
                console.log('Variant not found for this params');
            }
        } else {
            console.log('Product not found by current product_id.');
        }
    });

    colorButtons.forEach(function(button) {
        button.addEventListener('change', function() {
            var fieldset = button.closest('fieldset');
            var productId = fieldset.getAttribute('data-product-id');
            var size = fieldset.getAttribute('data-size');
            var colorValue = button.value;
            var product = all_variants.find(function(item) {
                return item.product_id === productId;
            });
            if (product) {
                var variant = product.variants.find(function(item) {
                    return item.options[0] === size && item.options[1] === colorValue;
                });

                if (variant) {
                    var newImageSrc = variant.feautured_image;
                    var newVariantPrice = variant.price;
                    console.log('newVariantPrice');
                    console.log(newVariantPrice);
                    var newHref = variant.url;
                    var priceDiv = button.closest('.collection-grid-item').querySelector('.collection-product--price');
                    var imageDiv = button.closest('.collection-grid-item').querySelector('.collection-product--image img');
                    var Href = button.closest('.collection-grid-item').querySelector('a');
                    if (priceDiv) {
                        priceDiv.textContent = newVariantPrice;
                    } else {
                        console.log('div with price not found.');
                    }
                    if (Href) {
                        Href.href = newHref;
                    } else {
                        console.log('"a" tag not found.');
                    }
                    if (imageDiv) {
                        imageDiv.src = newImageSrc;
                    } else {
                        console.log('div with image not found.');
                    }
                } else {
                    console.log('Variant not found for click params');
                }
            } else {
                console.log('Product not found by current product_id.');
            }

        });
    });
});